import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PlayerBalance from './PlayerBlance';
import PlayerPopBalance from './PlayerPopBalance';

import * as constants from '../../../../../../constants/constants';
import PlayerHand from './PlayerHand';

import lastRoundBell from '../../../../../../images/icons/last_round_bell.png';
import { Media } from 'reactstrap';
import IconPopover from '../../../Components/Components/IconPopover';
import { useTranslation } from 'react-i18next';


const PlayerInfo = React.memo(({
  name,
  bal,
  rating,
  largePlayer,
  uid,
  myId,
  screenMode,
  activePos,
  gameState,
  currentHand,
  playerPosition,
  currentTurn,
  tournamentRoom,
  curTournament,
  windowWidth,
}) => {
  const { t } = useTranslation('common');

  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const [lastRoundBellOpen, setLastRoundBellOpen] = React.useState(false);


  const onHover = () => {
    if (bal <= constants.PLAYER_ZOLE_RANGE.min) {
      setPopoverOpen(true);
    }
  };

  const onHoverLeave = () => {
    setPopoverOpen(false);
  };

  return (
    <Fragment>
      <div className={`player-name-wrapper ${largePlayer ? 'player-name-wrapper-large' : ''} ${activePos ? 'player-name-wrapper-active' : ''}`}>
        <div className="player-name">
          {name}
        </div>
        <PlayerHand
          gameState={gameState}
          currentHand={currentHand}
          playerPosition={playerPosition}
          currentTurn={currentTurn}
        />


        {uid === myId && tournamentRoom && curTournament?.rounds === curTournament?.currentRound && (
          <Fragment>
            <Media
              src={lastRoundBell}
              style={windowWidth > 1280
                ? {position: 'absolute', width: 30, left: -80, bottom: 0, transform: 'translate(-50%, -50%)', cursor: 'pointer', pointerEvents: 'all'}
                : {position: 'absolute', width: 30, left: -80, bottom: 0, transform: 'translate(-50%, -50%)', cursor: 'pointer', pointerEvents: 'all', zIndex: 999}}
              onMouseEnter={() => setLastRoundBellOpen(true)}
              onMouseLeave={() => setLastRoundBellOpen(false)}
              id="last-round-bell"
            />
            <IconPopover text={t('notifications:lastRoundTooltip')} targetId="last-round-bell" popoverOpen={lastRoundBellOpen} placement="top" />
          </Fragment>
        )}
      </div>
      {
        uid === myId ? (
          <PlayerPopBalance bal={bal} rating={rating} onHover={onHover} onHoverLeave={onHoverLeave} popoverOpen={popoverOpen} screenMode={screenMode} />
        ) : (
          <PlayerBalance bal={bal} rating={rating} onHover={onHover} onHoverLeave={onHoverLeave} />
        )
      }

    </Fragment>
  );
});

PlayerInfo.propTypes = {
  name: PropTypes.string,
  bal: PropTypes.number,
  rating: PropTypes.number,
  largePlayer: PropTypes.bool,
  uid: PropTypes.string,
  myId: PropTypes.string,
  activePos: PropTypes.string,

  gameState: PropTypes.string,
  currentHand: PropTypes.number,
  playerPosition: PropTypes.string,
  currentTurn: PropTypes.string,
};

PlayerInfo.defaultProps = {
  name: null,
  bal: null,
  rating: null,
  largePlayer: false,
  uid: null,
  myId: null,
  activePos: null,

  gameState: null,
  currentHand: null,
  playerPosition: null,
  currentTurn: null,
};

export default PlayerInfo;
